import FeeLabelList from '@/components/FeeLabel/FeeLabelList'
import FeeLabelForm from '@/components/FeeLabel/FeeLabelForm'

// Les deux bibliothèques du module Location pour compte relèvent de la même permission :
// côté client, la personne qui administre le catalogue LPC est celle qui traite les demandes.
let FeeLabelRouter = [{
  path: '/fee-label',
  name: 'FeeLabelList',
  component: FeeLabelList,
  meta: {
    title: 'Libellés de frais',
    requiresAuth: true,
    authorizations: ['location-for-account_index', 'desktop_access']
  }
}, {
  path: '/fee-label/new',
  name: 'FeeLabelNew',
  component: FeeLabelForm,
  meta: {
    title: 'Nouveau libellé de frais',
    requiresAuth: true,
    authorizations: ['location-for-account_new', 'desktop_access']
  }
}, {
  path: '/fee-label/:id/edit',
  name: 'FeeLabelEdit',
  component: FeeLabelForm,
  meta: {
    title: 'Modifier un libellé de frais',
    requiresAuth: true,
    authorizations: ['location-for-account_edit', 'desktop_access']
  }
}]

export default FeeLabelRouter



// WEBPACK FOOTER //
// ./src/components/FeeLabel/router.js